module.exports = __webpack_public_path__ + "static/media/5.7a170001.jpg";